import React, {Component} from 'react';
import Radium from 'radium';
import PropTypes from 'prop-types';
import InputText from 'components/input-text';
import {isPositiveNonZeroInteger, silverInfoStyles} from '../../../../../../utils/General';
import Translate from '../../../../../../components/Translate';

const style = {
    instructionsTitle: {
        fontSize: '14px',
        color: '#09183A',
        fontWeight: 400,
    },
    triggerWrapper: {
        // backgroundColor: '#F2F5FC',
        padding: '5px',
        margin: '10px'
    },
    checkBoxStyles: {
        color: '#09183A',
    },
    stylesWrapper: {
        padding: '25px 40px',
    },
    stylesDemoWrapper: {
        display: 'flex',
    },
    header: {
        fontSize: '16px',
        lineHeight: '20px',
        marginLeft: '20px',
        fontWeight: 'inherit',
        color: '#A4ADC1',
    },
    description: {
        fontSize: '16px',
        lineHeight: '20px',
        marginLeft: '74px',
        marginBottom: '10px',
        color: 'rgb(164, 173, 193)',
    },
    inputStyle: {
        width: '95px',
        border: 'none',
        height: '38px'
    },
    inputWrapper: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: '76px',
        border: '1px solid #A4ADC1',
        height: '40px',
        width: '147px',
        borderRadius: '10px',
        marginTop: '10px'
    },
};


class Triggers extends Component {
    handlePeriodStatusChange = (checked) => {
        const {triggers: {openAfterPeriod}} = this.props;
        const newPeriod = openAfterPeriod === -1 ? 5 : openAfterPeriod;
        const data = checked ? {openAfterPeriod: newPeriod} : {openAfterPeriod: -1};
        const {saveTriggers} = this.props;
        saveTriggers(data);
    };

    handlePeriodChange = (value) => {
        const {saveTriggers} = this.props;
        saveTriggers({openAfterPeriod: value});
    };

    render() {
        const {commonStyles, triggers: {openAfterPeriod}} = this.props;

        const isDisableOpenAfterPeriod = openAfterPeriod === -1;

        return (
            <div style={style.triggerWrapper}>
                <div style={{display: 'flex', alignItems: 'center', gap: '20px'}}>
                    <h2 style={[commonStyles.sectionTitle, commonStyles.bottomMargin]}>
                        <Translate text="settingTheTriggerForStartingTheChat"/>
                    </h2>
                </div>
                <div style={{display: "flex"}}>
                    <label className="switch controller">
                        <input
                            type="checkbox"
                            checked={!isDisableOpenAfterPeriod}
                            onChange={(event) => {
                                this.handlePeriodStatusChange(event.target.checked);
                            }}/>

                        <span className="slider round"/>
                    </label>
                    <h2 style={silverInfoStyles.info}>
                        <Translate text="enable/disable"/>
                    </h2>
                </div>

                <div style={{marginLeft: '74px', marginTop: '20px'}}>
                    {openAfterPeriod !== -1 &&
                        <React.Fragment>

                            <div style={{...style.inputWrapper, marginLeft: '0'}}>
                                <InputText
                                    inputStyles={style.inputStyle}
                                    defaultValue={openAfterPeriod}
                                    validate={isPositiveNonZeroInteger}
                                    handleChange={this.handlePeriodChange}
                                />
                                <div style={style.textDivStyle}>
                                    <p><Translate text={'sec'}/></p>
                                </div>
                            </div>

                        </React.Fragment>
                    }
                </div>
            </div>
        );
    }
}

Triggers.propTypes = {
    commonStyles: PropTypes.object.isRequired,
    triggers: PropTypes.object.isRequired,
    saveTriggers: PropTypes.func.isRequired,
};

export default Radium(Triggers);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/webchat-conf/Triggers.jsx